import styled from "styled-components";

export const CompItem = styled.div<{ selected?: boolean }>`
  position: relative;
  display: flex;
  flex: 1 0;
  width: 20%;
  flex-direction: column;
  padding: 5px 0px 5px 0px;
  align-items: center;
  cursor: pointer;
  border-radius: 0.8rem;
  background-color: ${(props) => (props.selected ? props.theme.white : "none")};
  color: ${(props) =>
    props.selected ? props.theme.midnightBlue : props.theme.white};
  font-weight: ${(props) => (props.selected ? "bold" : null)};

  &:nth-last-child(n + 2) {
    &:after {
      content: "";
      position: absolute;
      top: 6px;
      right: -1px;
      z-index: 1;
      width: 1px;
      height: 12px;
      background: ${(props) => props.theme.taupeGrey};
    }
  }
`;
